<template>
  <el-card
    shadow="always"
    :body-style="{ padding: '20px' }"
    v-loading="csvLoading"
  >
    <el-form
      :model="csvSettings"
      :inline="true"
      ref="csvLoadingForm"
      size="medium"
    >
      <el-form-item
        label="Дата"
        prop="date"
        class="form-element-without-margin"
      >
        <el-date-picker
          type="date"
          placeholder="Pick a date"
          v-model="csvSettings.date"
        ></el-date-picker>
      </el-form-item>
      <el-form-item class="form-element-without-margin">
        <el-button :loading="csvLoading" icon="el-icon-download" @click="getCsv">CSV</el-button>
      </el-form-item>
    </el-form>
  </el-card>
</template>
<script>
import {getCsvRatesForDate} from "../../../../../api";
export default {
  name: "LedgerHistoricalCoursesComponent",
  data: () => ({
    csvLoading: false,
    csvSettings: {
      date: new Date((new Date()).valueOf() - 1000*60*60*24),
    },
  }),
  computed: {},
  methods: {
    async getCsv(query = {}) {
      try {
        this.csvLoading = true;

        if (! this.csvSettings.date) {
          this.csvSettings.date = new Date();
        }

        const { data } = await getCsvRatesForDate(this.csvSettings.date);
        const fileURL = window.URL.createObjectURL(new Blob([data]));
        const fileLink = document.createElement("a");

        fileLink.href = fileURL;
        fileLink.setAttribute(
          "download",
          `historical_courses_${this.$dayjs(this.csvSettings.date).format("DD_MM_YYYY")}.csv`
        );

        document.body.appendChild(fileLink);

        fileLink.click();
      } catch (error) {
        this.handleResponseError(error);
      } finally {
        this.csvLoading = false;
      }
    }
  }
};
</script>
<style scoped>
.form-element-without-margin {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Ledger/components/Balances/historicalCourses.vue